import { useMemo } from 'react';
import { useAuthStore } from '@/store';
import { hasPermission } from '@/lib/permission-match';

/** 当前登录用户的平台权限码是否包含某一项（含 platform:* 通配） */
export function usePlatformPermission(code: string): boolean {
  const perms = useAuthStore((s) => s.user?.permissions ?? []);
  return useMemo(() => hasPermission(perms, code), [perms, code]);
}
